<template>
    <div v-if="actionComponent">
        <component
            :is="actionComponent"
            :action="pendingAction"
            @answered="answered"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextAction from "./text/RequireText";
import FileAction from "./file/RequireFile";
import DateAction from "./date/RequireDate";
import GetSurveyAction from "./get-survey/RequireGetSurvey";
import moment from "moment";

export default {
    name: "base-require-action",
    props: {
        signalRSocket: { type: Object, required: true },
    },
    mounted() {
        this.signalRSocket.on(
            "RequireTextAction",
            this.signalRRequireTextAction
        );
        this.signalRSocket.on(
            "ReceiveTextActionAnswer",
            this.signalRReceiveTextActionAnswer
        );

        this.signalRSocket.on(
            "RequireFileAction",
            this.signalRRequireFileAction
        );

        this.signalRSocket.on(
            "ReceiveFileActionAnswer",
            this.signalRReceiveFileActionAnswer
        );

        this.signalRSocket.on(
            "ReceivePhotoActionAnswer",
            this.signalRReceivePhotoActionAnswer
        );

        this.signalRSocket.on(
            "ReceiveSignAnswer",
            this.signalRReceiveSignAnswer
        );

        this.signalRSocket.on(
            "ReceiveShareDocumentAction",
            this.signalRReceiveShareDocumentAction
        );

        this.signalRSocket.on(
            "RequireDateAction",
            this.signalRRequireDateAction
        );

        this.signalRSocket.on(
            "ReceiveDateActionAnswer",
            this.signalRReceiveDateActionAnswer
        );

        this.signalRSocket.on(
            "ReceiveSignActionAnswer",
            this.signalRReceiveSignActionAnswer
        );

        this.signalRSocket.on(
            "RequireGetSurvey",
            this.signalRRequireGetSurveyAction
        );

        this.signalRSocket.on(
            "ReceiveGetSurveyActionAnswer",
            this.signalRReceiveGetSurveyActionAnswer
        );
    },
    computed: {
        ...mapGetters("actions", ["getPendingAction", "getAction"]),
        ...mapGetters("conference", ["getParticipantId"]),
        pendingAction() {
            return this.getPendingAction(this.getParticipantId);
        },
        actionComponent() {
            let pendingAction = this.pendingAction;
            switch (pendingAction.type) {
                case "text":
                    return TextAction;
                case "file":
                    return FileAction;
                case "date":
                    return DateAction;
                case "get-survey":
                    return GetSurveyAction;
            }
            return null;
        },
    },
    methods: {
        ...mapActions("actions", ["setActionAnswer", "addAction"]),
        ...mapActions("chat", ["addMessage"]),
        ...mapActions("colaborativeBoard", ["setFileId", "setSurveyId"]),
        ...mapGetters("oidcStore", ["oidcIsAuthenticated"]),
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        answered(payload) {
            switch (payload.type) {
                case "text":
                    return this.AnswerText(payload);
                case "file":
                    return this.AnswerFile(payload);
                case "date":
                    return this.AnswerDate(payload);
                case "get-survey":
                    return this.AnswerGetSurvey(payload);
            }
        },
        AnswerText(payload) {
            this.signalRSocket.invoke(
                payload.socketName,
                payload.roomId,
                payload.actionId,
                payload.answer
            );
        },
        AnswerFile(payload) {
            this.signalRSocket.invoke(
                payload.socketName,
                payload.roomId,
                payload.actionId,
                payload.answer.fileId,
                payload.answer.fileName
            );
        },
        AnswerDate(payload) {
            this.signalRSocket.invoke(
                payload.socketName,
                payload.roomId,
                payload.actionId,
                payload.answer
            );
        },
        AnswerGetSurvey(payload) {
            this.signalRSocket.invoke(
                payload.socketName,
                payload.roomId,
                payload.actionId,
                payload.answer
            );
        },
        signalRRequireTextAction(response) {
            let action = {
                id: response.id,
                state: response.state,
                title: response.title,
                user: response.participant,
                date: new Date(),
                type: "text",
            };
            this.addAction(action);
        },
        signalRReceiveTextActionAnswer(response) {
            this.setActionAnswer(response);
            let action = this.getAction(response.id);
            this.addMessage({
                notification: `A '${action.title}' el usuario '${action.user.name}' respondio '${action.answer}'.`,
            });
        },
        signalRRequireGetSurveyAction(response) {
            let action = {
                id: response.id,
                state: response.state,
                title: response.title,
                user: response.participant,
                date: new Date(),
                type: "get-survey",
            };
            this.addAction(action);
        },
        signalRReceiveGetSurveyActionAnswer(response) {
            this.setActionAnswer(response);
            let action = this.getAction(response.id);
            this.addMessage({
                notification: `A '${action.title}' el usuario '${action.user.name}' respondio '${action.answer}'.`,
            });
            if (this.isLogged) {
                this.setSurveyId({ surveyId: response.answer });
            }
        },
        signalRRequireDateAction(response) {
            let action = {
                id: response.id,
                state: response.state,
                title: response.title,
                user: response.participant,
                date: new Date(),
                type: "date",
                minDate: response.minDate,
                maxDate: response.maxDate,
            };
            this.addAction(action);
        },
        signalRReceiveDateActionAnswer(response) {
            var date = moment(response.answer, "YYYY-MM-DDTHH:mm:ss");

            response.answer = date.format("DD/MM/yyyy");
            this.setActionAnswer(response);
            let action = this.getAction(response.id);
            this.addMessage({
                notification: `A '${action.title}' el usuario '${action.user.name}' respondio '${action.answer}'.`,
            });
        },
        signalRRequireFileAction(response) {
            let action = {
                id: response.id,
                state: response.state,
                title: response.title,
                user: response.participant,
                date: new Date(),
                type: "file",
            };
            this.addAction(action);
        },
        signalRReceiveFileActionAnswer(response) {
            this.setActionAnswer(response);
            let action = this.getAction(response.id);
            this.addMessage({
                notification: `A '${action.title}' el usuario '${action.user.name}' respondio '${response.answer.fileName}'`,
            });
        },
        signalRReceiveSignActionAnswer(response) {
            this.setActionAnswer(response);
            let action = this.getAction(response.id);
            this.addMessage({
                notification: `El usuario '${action.user.name}' ha firmado un documento`,
            });
        },
        signalRReceivePhotoActionAnswer(response) {
            let action = response;
            action.date = new Date();
            action.state = 1;
            this.addAction(action);
            action = this.getAction(action.id);
            this.addMessage({
                notification: `A '${action.title}' el usuario '${action.user.name}' respondio '${response.answer.fileName}'`,
            });
        },
        signalRReceiveSignAnswer(response) {
            let action = {
                date: new Date(),
                state: 1,
                title: `Firma ${response.userName}`,
                type: "sign",
                user: {
                    name: response.userName,
                },
                answer: {
                    fileId: response.fileId,
                },
            };
            this.addAction(action);
            this.addMessage({
                notification: `El usuario '${response.userName}' ha firmado un documento`,
            });
        },
        signalRReceiveShareDocumentAction(response) {
            this.setFileId({ fileId: response.fileId, page: 1 });

            this.addMessage({
                notification: `El usuario '${response.user}' ha compartido un documento'`,
            });
        },
    },
};
</script>